import type { App } from 'vue'
import { CHAVE_OPERACOES_CATALOGO_LOCAL_DE_TRABALHO } from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/apresentacao/catalogo-local-de-trabalho.injecao'
import type { OperacoesCatalogoLocalDeTrabalho } from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/catalogo-local-de-trabalho.tipos'
import {
  criarCasoDeUsoListarOpcoesLocal,
} from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/listar-opcoes/listar-opcoes-local'
import {
  ListarOpcoesLocalRepositorioHttp,
} from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/listar-opcoes/listar-opcoes-local.repositorio-http'

import type { InfraestruturaAplicacao } from '../criar-infraestrutura'

export const comporCatalogoLocalDeTrabalho = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoLocalDeTrabalho => {
  const repositorio = new ListarOpcoesLocalRepositorioHttp(
    infraestrutura.httpCondominio,
  )

  return {
    listarOpcoes: criarCasoDeUsoListarOpcoesLocal(repositorio.executar),
  }
}

export const instalarLocalDeTrabalho = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
): void => {
  app.provide(
    CHAVE_OPERACOES_CATALOGO_LOCAL_DE_TRABALHO,
    comporCatalogoLocalDeTrabalho(infraestrutura),
  )
}
